import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ExperienceBlock } from '@sorare/core/src/components/landing/ExperienceBlock';
import { messages } from '@sorare/core/src/components/landing/LandingMultiSport/Experience';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

import { MarketPlaceDialog } from './MarketPlaceDialog';
import competeImage from './assets/competeImage.jpg';
import competeVideo from './assets/competeVideo.webm';
import createImage from './assets/createImage.jpg';
import createImageMobile from './assets/createImageMobile.jpg';
import strengthenImage from './assets/strengthenImage.jpg';
import strengthenSlideShow_1 from './assets/strengthenSlideShow/1.jpg';
import strengthenSlideShow_2 from './assets/strengthenSlideShow/2.jpg';
import strengthenSlideShow_3 from './assets/strengthenSlideShow/3.jpg';
import strengthenSlideShow_4 from './assets/strengthenSlideShow/4.jpg';
import strengthenSlideShow_5 from './assets/strengthenSlideShow/5.jpg';
import winRewardsImage from './assets/winRewardsImage.jpg';
import winRewardsImageMobile from './assets/winRewardsImageMobile.jpg';

const nbaMessages = defineMessages({
  createText: {
    id: 'Landing.NBA.Experience.createText',
    defaultMessage:
      "Create your fantasy roster by scouting and collecting digital player cards from all 30 NBA teams. Set your starting lineup and play in free, twice-weekly competitions for prizes based on your players' real-life performance. Start playing at any time during the season.{br}{br}Sorare's skill-based game rewards your NBA knowledge and lineup strategy.",
  },
  strengthenText: {
    id: 'Landing.NBA.Experience.strengthenText',
    defaultMessage:
      "Buy, sell, and trade digital NBA cards on Sorare's live Market - which features hundreds of players - week over week and season over season. Improve your lineups by adding top performers for an immediate roster boost, or rising prospects for long-term production.",
  },
});

export const Experience = () => {
  const track = useEvents();
  const { formatMessage } = useIntl();
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <ExperienceBlock
        title={formatMessage({
          id: 'Landing.NBA.Experience.title2',
          // \u00a0 is the unicode for a non-breaking space
          defaultMessage:
            'Experience fantasy NBA like a PRO general\u00a0manager',
        })}
        blocks={[
          {
            title: formatMessage(messages.createTitle),
            text: formatMessage(nbaMessages.createText, { br: <br /> }),
            imageSrc: { default: createImage, mobile: createImageMobile },
          },
          {
            title: formatMessage(messages.competeTitle),
            text: formatMessage(messages.competeText),
            imageSrc: { default: competeImage },
            videoSrc: { default: competeVideo },
            slideShow: [
              strengthenSlideShow_1,
              strengthenSlideShow_2,
              strengthenSlideShow_3,
              strengthenSlideShow_4,
              strengthenSlideShow_5,
            ],
          },
          {
            title: formatMessage(messages.strengthenTitle),
            text: formatMessage(nbaMessages.strengthenText),
            cta: formatMessage(messages.strengthenCTA),
            ctaAction: () => {
              track('Click Scout the Marketplace');
              setOpenDialog(true);
            },
            imageSrc: { default: strengthenImage },
          },
          {
            title: formatMessage(messages.winRewardsTitle),
            text: formatMessage(messages.winRewardsText, { br: <br /> }),
            imageSrc: {
              default: winRewardsImage,
              mobile: winRewardsImageMobile,
            },
          },
        ]}
      />
      <MarketPlaceDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      />
    </>
  );
};
